import { LayersControl, TileLayer } from 'react-leaflet';

const LAYERS = [
    { name: 'نقشه استاندارد', checked: true, url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', attribution: '&copy; OpenStreetMap contributors' },
    { name: 'روشن', url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png', attribution: '&copy; OpenStreetMap &copy; CARTO' },
    { name: 'تیره', url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png', attribution: '&copy; OpenStreetMap &copy; CARTO' },
    { name: 'ماهواره‌ای', url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', attribution: '&copy; Esri' },
];

export default function BaseLayers({ position = 'topright' }) {
    return (
        <LayersControl position={position}>
            {LAYERS.map(layer => (
                <LayersControl.BaseLayer key={layer.name} name={layer.name} checked={!!layer.checked}>
                    <TileLayer url={layer.url} attribution={layer.attribution} />
                </LayersControl.BaseLayer>
            ))}
        </LayersControl>
    );
}
